import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Input, Alert, Radio, Typography, Select } from 'antd'
import getHistory from '../../../../../helpers/rounting/getHistory'
import queryString from "query-string"
import { createBatchV3, listPartner, listLevels } from "../../../../../services/api/3dApi"

const { Text } = Typography
const { Option } = Select

class CreateBatchV2 extends Component {
    state = {
        isOpen: true,
        loading: false,
        params: this.props.query,
        message: '',
        limit: null,
        userCreate: '',
        level: "1",
        error: '',
        levels: [],
        partner: '',
        partners: [],
        errorPartner: ''
    }

    componentDidMount() {
        this._fetchLevel()
        this._fetchPartner()
    }


    _handleChangeNumber = (e) => {
        const { value } = e.target

        this.setState({
            limit: parseInt(value)
        })
    }

    _handleChangeText = (e) => {
        const { value } = e.target

        this.setState({
            userCreate: value.trim()
        })
    }

    _onChangeRadio = (e) => {
        this.setState({
            level: e.target.value
        })
    }

    _onChangeSelect = (value) => {
        this.setState({
            partner: value
        })
    }

    _validate = (value) => {
        if (value === null || isNaN(value)) {
            this.setState({
                loading: false,
                message: 'Số item nhập vào là rỗng.'
            })
            return false
        }

        if (value === 0) {
            this.setState({
                loading: false,
                message: 'Số item nhập vào phải khác 0.'
            })
            return false
        }
    }

    _handleSubmit = async (e) => {
        e.preventDefault()

        this.setState({
            loading: true
        })

        const { limit, userCreate, partner } = this.state

        if (this._validate(limit) === false) {
            return
        }

        try {
            const { params, level } = this.state
            const payload = {
                ...params,
                user_create: userCreate,
                limit: limit,
                level: level,
                partner: partner
            }

            const { data: response } = await createBatchV3(payload)

            const { success, error, data } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                loading: false,
                isOpen: false
            })

            if (data.batch._id) {
                const history = getHistory()
                history.push(`/batches/${data.batch._id}`)
            }
        } catch (error) {
            this.setState({
                loading: false,
                message: error.message
            })
        }
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction1' onClick={this._closeModal}
            disabled={this.state.loading}>Hủy</Button>
        const buttonOk = <Button loading={this.state.loading} key='btnOKBulkAction1' type='primary'
            onClick={this._handleSubmit} disabled={this.state.loading}>Tạo</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false
        })
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    _fetchPartner = async () => {
        try {
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)

            const { data, success, error } = response

            if (!success) {
                this.setState({
                    errorPartner: error
                })

                return
            }

            this.setState({
                partners: data.partners
            })
        } catch (e) {
            this.setState({
                errorPartner: e.message
            })
        }
    }

    _fetchLevel = async () => {
        try {
            const { data: response } = await listLevels()

            const { data, success, error } = response

            if (!success) {
                this.setState({
                    error: error
                })

                return
            }

            this.setState({
                levels: data
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const { isOpen, message, level, error, levels, errorPartner, partner, partners } = this.state
        const modalFooter = this._renderModalFooter()

        return (
            <Modal
                visible={isOpen}
                title='Tạo lô theo số lượng'
                className='GenerateTemplateByQuery'
                afterClose={this._handleAfterClose}
                closable={false}
                footer={modalFooter}
            >
                {
                    message && <Alert className="mb-3" message="Lỗi" description={message} type="error" />
                }

                <div>
                    <label htmlFor='itemNumber' className='fs-16 font-weight-bold'>
                        Nhập số lượng items của lô:
                    </label>
                    <Input type="number" min="1" placeholder="Nhập số items của Lô"
                        onChange={this._handleChangeNumber}
                        rules={[{ type: 'number', min: 0, message: 'Vui lòng nhập vào một số.' }]}
                    />

                    <label className="mt-3 font-weight-bold">Người tạo:</label>
                    <Input type="text" placeholder="Nhập tên người tạo" onChange={this._handleChangeText} />

                    <label className='mt-3 d-block font-weight-bold'>Đối tác in/ép:</label>
                    {
                        !!errorPartner ? <Text type='danger'>{errorPartner}</Text> :
                            <Select
                                onChange={this._onChangeSelect}
                                value={partner}
                                className='customSelect'
                                dropdownClassName='custom-select-partner'
                            >
                                <Option value={''}>---Hãy chọn 1 đối tác---</Option>
                                {
                                    partners.length > 0 && partners.map(item => (
                                        <Option key={item._id} value={item._id}>{item.name}</Option>
                                    ))
                                }
                            </Select>
                    }

                    <label className='mt-3 d-block font-weight-bold'>
                        Độ ưu tiên:
                    </label>
                    {
                        error ?
                            <Text type='danger'>{error}</Text> :
                            <Radio.Group onChange={this._onChangeRadio} value={level}>
                                {
                                    levels.length > 0 && levels.map(item => <Radio key={item.key} value={item.key}>{item.value}</Radio>)
                                }
                            </Radio.Group>
                    }
                </div>

            </Modal>
        )
    }
}

CreateBatchV2.propTypes = {
    onResetAction: PropTypes.func.isRequired,
    query: PropTypes.object.isRequired
}

export default CreateBatchV2
